import { REGISTRATION_STATUSES } from 'api/auth/constants'
import { MigrationSectionsStatuses, RegistrationStatuses } from 'api/auth/types'
import { MENU_ITEM_STATUS_MAP } from 'layouts/MainLayout/Menu/constants'
import { useAppSelector } from 'redux/hooks'
import { isMigratedUserSelector, userDataSelector } from 'redux/login/selectors'
import { MENU_NAMES } from 'texts/menuNames'

const newUserProtectedSections = [
  MENU_NAMES.PRICE_LISTS,
  MENU_NAMES.VEHICLES,
  MENU_NAMES.LOCATIONS,
  MENU_NAMES.TERMS_AND_CONDITIONS,
  MENU_NAMES.EQUIPMENTS,
  MENU_NAMES.STOP_SALES,
  MENU_NAMES.DROP_OFF_FEE,
  MENU_NAMES.BOOKING_HISTORY,
]

const migratedUserProtectedSections = [
  MENU_NAMES.PRICE_LISTS,
  MENU_NAMES.VEHICLES,
  MENU_NAMES.TERMS_AND_CONDITIONS,
  MENU_NAMES.EQUIPMENTS,
  MENU_NAMES.STOP_SALES,
  MENU_NAMES.DROP_OFF_FEE,
]

export const useDisableMenuItems = () => {
  const {
    accountStatus,
    sectionsStatuses,
    migrationSectionsStatuses,
    isProfileAndDocumentsAlreadyApproved,
  } = useAppSelector(userDataSelector)
  const isMigratedUser = useAppSelector(isMigratedUserSelector)

  const disableMenuItem = (name: string) => {
    if (!isMigratedUser) {
      const profileStatusKey = MENU_ITEM_STATUS_MAP[
        MENU_NAMES.PROFILE_DETAILS.NAME
      ] as keyof RegistrationStatuses
      const documentsStatusKey = MENU_ITEM_STATUS_MAP[
        MENU_NAMES.DOCUMENTS
      ] as keyof RegistrationStatuses

      const isProfileApproved =
        sectionsStatuses?.[profileStatusKey] === REGISTRATION_STATUSES.APPROVED
      const isDocumentsApproved =
        sectionsStatuses?.[documentsStatusKey] ===
        REGISTRATION_STATUSES.APPROVED
      const areDocumentsOrProfileApproved =
        isDocumentsApproved || isProfileAndDocumentsAlreadyApproved

      return (
        !!accountStatus &&
        accountStatus !== 'Approved' &&
        newUserProtectedSections.includes(name) &&
        (!isProfileApproved || !areDocumentsOrProfileApproved)
      )
    } else {
      if (typeof migrationSectionsStatuses === 'undefined') {
        return false
      }
      if (
        name === MENU_NAMES.VEHICLES ||
        name === MENU_NAMES.EQUIPMENTS ||
        name === MENU_NAMES.DROP_OFF_FEE
      ) {
        return (
          migrationSectionsStatuses?.[
            MENU_ITEM_STATUS_MAP[
              MENU_NAMES.LOCATIONS
            ] as keyof MigrationSectionsStatuses
          ] !== 'Complete'
        )
      }
      if (
        name === MENU_NAMES.PRICE_LISTS ||
        name === MENU_NAMES.TERMS_AND_CONDITIONS
      ) {
        return (
          migrationSectionsStatuses?.[
            MENU_ITEM_STATUS_MAP[
              MENU_NAMES.VEHICLES
            ] as keyof MigrationSectionsStatuses
          ] !== 'Complete'
        )
      }
      if (name === MENU_NAMES.STOP_SALES) {
        return (
          migrationSectionsStatuses?.[
            MENU_ITEM_STATUS_MAP[
              MENU_NAMES.PRICE_LISTS
            ] as keyof MigrationSectionsStatuses
          ] !== 'Complete'
        )
      }

      return (
        !!accountStatus &&
        accountStatus !== 'Approved' &&
        migratedUserProtectedSections.includes(name) &&
        sectionsStatuses?.[
          MENU_ITEM_STATUS_MAP[
            MENU_NAMES.PROFILE_DETAILS.NAME
          ] as keyof RegistrationStatuses
        ] !== REGISTRATION_STATUSES.APPROVED
      )
    }
  }

  return { disableMenuItem }
}
